import { NEW_MODULE_API } from "../Helpers/Enums";
import globalRequest from "./globalRequest";

const getAlertEnrich = async (userId) => {
  return await globalRequest("get", NEW_MODULE_API.GET_ALERT(userId), {}, {}, true);
};

export default getAlertEnrich;
